import React, { useEffect, useState } from 'react';
import { Navbar } from './Components/NavBar/Navbar';
import { Welcome } from './Components/Welcome/Welcome';
import { StoryBackground } from './Components/Welcome/StoryBackground';
import './App.scss'

import { handleOnMove, updateLastMousePosition, originPosition } from './MouseEffects';
import { loadCourseContent } from './data/courseContent';
import {
  DEFAULT_SIMULATED_DATE,
  SIM_DATE_CHANGE_EVENT,
  canSimulateDate,
  getSimulatedDate,
  setSimulatedDate,
} from './data/releaseSchedule';

export interface SectionProps {
    static?: boolean;
}

function App() {
  const [contentState, setContentState] = useState<"loading" | "ready" | "error">(
    "loading"
  );
  const [simulatedDate, setSimulatedDateState] = useState<string | null>(
    () => getSimulatedDate()
  );

  useEffect(() => {
    const handleTouchMove = (e: TouchEvent) => handleOnMove(e);
    const handleMouseLeave = () => updateLastMousePosition(originPosition);
    const syncSimulatedDate = () => {
      setSimulatedDateState(getSimulatedDate());
    };

    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    if (!window.location.hash) {
      window.scrollTo(0, 0);
    }

    window.addEventListener('touchmove', handleTouchMove);
    window.addEventListener(SIM_DATE_CHANGE_EVENT, syncSimulatedDate);
    document.body.addEventListener('mouseleave', handleMouseLeave);

    loadCourseContent()
      .then(() => setContentState("ready"))
      .catch((error) => {
        console.error(error);
        setContentState("error");
      });

    return () => {
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener(SIM_DATE_CHANGE_EVENT, syncSimulatedDate);
      document.body.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  const handleSimulatedDateChange = (ymd: string) => {
    setSimulatedDate(ymd);
    setSimulatedDateState(ymd);
  };

  if (contentState !== "ready") {
    return (
      <div className="app scroll-story-app">
        <div className="course-content-status" role="status">
          {contentState === "loading" ? (
            "Loading course content…"
          ) : (
            <>
              Couldn’t load <code>content/course.json</code>. For local
              testing that file lives in <code>public/content/</code>.
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="app scroll-story-app">
      <StoryBackground />
      <Navbar
        simulatedDate={
          canSimulateDate()
            ? simulatedDate ?? DEFAULT_SIMULATED_DATE
            : undefined
        }
        onSimulatedDateChange={handleSimulatedDateChange}
      />
      <Welcome key={simulatedDate ?? "real"} />
    </div>
  );
}

export default App;
